import type { SportsApi } from "@/v2/api/metadata/sports";
import {
  addFeedMappingRow,
  buildFeedMappingGrid,
  createFeedMappingSubmitGate,
  fetchFeedTypeMappingsList,
} from "@/v2/kits/feed-mapping";
import type { GridTab, GridTabSaveContext } from "@/v2/framework/dialog/types";
import { notifySuccess, sportId } from "../shared";

export function createFeedMappingTab(sportsApi: SportsApi): GridTab {
  async function save(ctx: GridTabSaveContext): Promise<void> {
    const gate = ctx.gate;
    if (!gate?.hasSuccessfulLoad() || !gate.isDirty()) return;
    if (!gate.validateForDialogSubmit()) {
      throw new Error("Please fill the required fields");
    }

    const fragment = gate.buildMergeFragment();
    if (!fragment) return;

    const entityId = sportId(ctx.values);
    await sportsApi.update(entityId, fragment);

    if (!ctx.rows) {
      throw new Error("Feed mapping grid is not available");
    }

    ctx.rows.value = await fetchFeedTypeMappingsList(sportsApi.getFeedTypeMappings, entityId, {
      isReadAfterWrite: true,
    });
    gate.markClean?.();
    notifySuccess();
  }

  return {
    kind: "grid",
    id: "feed-mapping",
    label: "Feed mapping",
    createGrid: (getValues) =>
      buildFeedMappingGrid(
        () => sportId(getValues()),
        sportsApi.getFeedTypeMappings.bind(sportsApi),
      ),
    createSubmitGate: createFeedMappingSubmitGate,
    save,
    addRowLabel: "common.buttons.add_new",
    onAddRow: addFeedMappingRow,
  };
}
